import { Issue as ServerIssue } from 'server/models/Issue';
import { IssueType } from './IssueType';

export { IssueOptions, IssueData } from 'server/models/Issue';

export class Issue extends ServerIssue {
    // Use this precedence to sort issues that have the same Severity.
    // Greater number means higher precedence.
    static IssuePrecedence(issue : Issue) {
        return (
            issue.Type() === IssueType.ReservationOverlapsBerthClosure   ? 6 :
            issue.Type() === IssueType.ReservationExceedsBerthLength     ? 5 :
            issue.Type() === IssueType.ReservationExceedsBerthDepth      ? 4 :
            issue.Type() === IssueType.ReservationOverlapsOther          ? 3 :
            issue.Type() === IssueType.ReservationOverlapsShift          ? 2 :
            issue.Type() === IssueType.ReservationOverlapsVesselSchedule ? 1 :
            issue.Type() === IssueType.ReservationLacksKnownVessel       ? 0 :
            -1
        );
    }

    /** Sort issues by Severity, then by Precedence, from lowest severity/precedence to highest. */
    static PrecedenceOrder(issue1 : Issue, issue2 : Issue) {
        return (
            issue1.Severity() - issue2.Severity() ||
            Issue.IssuePrecedence(issue1) - Issue.IssuePrecedence(issue2) ||
            0
        );
    }

    /** Sort issues by Severity, then by Precedence, from highest severity/precedence to lowest. */
    static ReversePrecedenceOrder(issue1 : Issue, issue2 : Issue) {
        return Issue.PrecedenceOrder(issue2, issue1);
    }

    // Highest priority issue out of a list of issues, or null if list is empty.
    static TopIssue(issues : Issue[]) {
        let top = null as Issue | null
        issues.forEach(i => top = (top === null || Issue.PrecedenceOrder(i, top) > 0 ? i : top));
        return top;
    }
}



// WEBPACK FOOTER //
// ./data/models/Issue.ts